import React from 'react'

import { useTranslation } from '@/core/i18n/useTranslation'
import Icon from '@/shared/components/atoms/Icon'

export const PaymentMethodSuccess: React.FC = () => {
	const { t } = useTranslation('common')

	return (
		<div className="bg-card border border-border rounded-xl p-6 mb-4">
			<div className="flex items-center gap-3">
				<Icon name="check-circle-fill" className="h-6 w-6 text-green-500" />
				<div>
					<h3 className="text-lg font-semibold">
						{t('subscribe.payment_method_saved')}
					</h3>
					<p className="text-sm text-muted-foreground">
						{t('subscribe.payment_method_saved_desc')}
					</p>
				</div>
			</div>
		</div>
	)
}
